import { Component, OnInit } from '@angular/core';
import { Organization } from '../../../utils/objects/organization';
import { ApiService } from '../../../utils/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ORGANIZATION_STATUSES } from '../../../utils/constants/constants';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-organization-detail',
  templateUrl: './organization-detail.component.html',
  styleUrls: ['./organization-detail.component.css']
})
export class OrganizationDetailComponent implements OnInit {
  public organizationStatuses = ORGANIZATION_STATUSES;

  public organization: Organization;
  public crossParameter;
  public viewType;

  public organizationAgencyControl: FormControl;
  public organizationStatusControl: FormControl;
  public twoFactorAuthenticationControl: FormControl;
  public orgaanizationSegmentControl: FormControl

  /// NULL Gelebilir
  public organizationAgencyID;
  public agencyCrossID;
  ////

  public parameter;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    this.organizationAgencyControl = new FormControl(null, Validators.required);
    this.organizationStatusControl = new FormControl(null, Validators.required);
    this.twoFactorAuthenticationControl = new FormControl(false);
    this.orgaanizationSegmentControl=new FormControl(null, Validators.required)

    this.viewType = this.activatedRoute.snapshot.data.viewType;

    this.organization = this.activatedRoute.snapshot.data.organizationData;
    this.organizationStatusControl.patchValue(this.organization.status);
    this.twoFactorAuthenticationControl.patchValue(this.organization.twoFactorType);
    if(this.viewType=='AGENCY'){
      this.orgaanizationSegmentControl.patchValue(this.organization.segment)
    }

    this.organizationStatusControl.valueChanges.subscribe(res => {
      this.updateOrganizationStatus(res);
    });

    this.twoFactorAuthenticationControl.valueChanges.subscribe(res => {
      if (this.organization['twoFactorType'] !== res)
        this.saveTwoFactorAuth(res);
    })
    this.twoFactorAuthenticationControl.valueChanges.subscribe(res => {
      if (this.organization['segment'] !== res)
        this.updateSegmentType();
    })

    switch (this.viewType) {
      case 'ORGANIZATION':
        this.organizationAgencyID = this.activatedRoute.snapshot.data
          .organizationAgencyData
          ? this.activatedRoute.snapshot.data.organizationAgencyData
            .granteeOrganizationId
          : null;
        this.agencyCrossID = this.activatedRoute.snapshot.data
          .organizationAgencyData
          ? this.activatedRoute.snapshot.data.organizationAgencyData.id
          : null;

        this.organizationAgencyControl.patchValue(
          this.organizationAgencyID ? this.organizationAgencyID : null
        );
        break;
      case 'AGENCY':
        this.orgaanizationSegmentControl.patchValue(this.organization.segment)
        break;
    }
  }
  loadingTwoFactor = false;
  saveTwoFactorAuth(value) {
    this.loadingTwoFactor = true;
    this.apiService.updateOrganization(this.organization.id, { organization_id: this.organization.id, twoFactorType: value }).subscribe(res => {
      this.loadingTwoFactor = false;
      this.organization.twoFactorType = res.data.twoFactorType;
      this.notificationsService.success('Success', value ? 'Two factor authentication is enabled!' : 'Two factor authentication is disabled');
    }, err => {
      this.loadingTwoFactor = false;
      this.notificationsService.error('Error', 'Operation failed!');
    });
  }

  updateAgency() {
    if (!this.organizationAgencyControl.value && this.agencyCrossID) {
      this.apiService.deleteCrossOrganization(this.organization.id, this.agencyCrossID).subscribe(res => {
        this.notificationsService.success('Success', 'Agency relation is removed successfully!');
      }, err => {
        this.notificationsService.error('Error', 'Error occured');
      })
    } else if (this.organizationAgencyControl.value) {

      if (this.agencyCrossID) {
        Observable.forkJoin(
          [
            this.apiService.deleteCrossOrganization(this.organization.id, this.agencyCrossID),
            this.apiService.insertCrossOrganization(this.organization.id, this.organizationAgencyControl.value)
          ]
        )
          .subscribe(
            response => {
              this.agencyCrossID = response[1]['data'].id;
              this.organizationAgencyID = response[1]['data'].granteeOrganizationId;
              this.notificationsService.success(
                'Success',
                'Related agency is updated'
              );
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            },
            error => {
              this.organizationAgencyControl.patchValue(
                this.organizationAgencyID ? this.organizationAgencyID : null
              );
              this.notificationsService.error('Error', 'Error occured');
            }
          );
      } else {
        this.apiService.insertCrossOrganization(this.organization.id, this.organizationAgencyControl.value).subscribe(res => {
          this.agencyCrossID = res['data'].id;
          this.organizationAgencyID = res['data'].granteeOrganizationId;
          this.notificationsService.success(
            'Success',
            'Related agency is updated'
          );
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }, err => {
          this.notificationsService.error('Error', 'Error occured');
        })
      }
    }
  }
  updateSegmentType() {
    this.organization.segment=this.orgaanizationSegmentControl.value
    this.apiService.updateOrganization(this.organization.id,this.organization).subscribe(res=>{
      this.organization=res['data'];
      this.notificationsService.success(
        'Success',
        'Organization segment is updated'
      )
    },
    error=>{
      this.notificationsService.error('Error','Error occured');
    });
  }

  updateOrganizationStatus(statusParam) {
    this.organization.status = statusParam;
    this.apiService
      .updateOrganization(this.organization.id, this.organization)
      .subscribe(
        response => {
          this.organization = response['data'];
          this.notificationsService.success(
            'Success',
            'Organization status is updated'
          );
        },
        error => {
          this.notificationsService.error('Error', 'Error occured');
        }
      );
  }

  inactivate() {
    this.apiService.inactivateOrganization(this.organization.id).subscribe(
      response => {
        this.organization.status = 'Inactive';
        this.notificationsService.success(
          'Success',
          'Organization status is updated'
        );
      },
      error => {
        this.notificationsService.error('Error', 'Error occured');
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/organization-detail/organization-detail.component.ts